module.exports = __webpack_public_path__ + "static/media/shopfinal.95045777.png";